import Cookies from 'js-cookie'

const TokenKey = 'User-Token'
const InfoKey = 'User-Info'

export function getToken() {
	return Cookies.get(TokenKey)
}

export function setToken(token) {
	return Cookies.set(TokenKey, token)
}

export function removeToken() {
	return Cookies.remove(TokenKey)
}

export function getInfo() {
	let info = Cookies.get(InfoKey)
	if(info){
		return JSON.parse(info)
	}else{
		return {}
	}
}

export function setInfo(info) {
	return Cookies.set(InfoKey, JSON.stringify(info))
}

export function removeInfo() {
	return Cookies.remove(InfoKey)
}